var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaPrenotazioni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 5.5376H2.22504M9.0625 7.88135C7.76584 7.88135 5.9375 7.88135 5.9375 7.88135M12.8125 5.85113V12.1782C12.8125 12.9117 12.2179 13.5063 11.4844 13.5063H3.51562C2.78212 13.5063 2.1875 12.9117 2.1875 12.1782V5.85113C2.1875 5.64494 2.23551 5.44159 2.32771 5.25717L3.24031 3.43197C3.40904 3.09451 3.75395 2.88135 4.13124 2.88135H10.8688C11.246 2.88135 11.591 3.09451 11.7597 3.43197L12.6723 5.25717C12.7645 5.44159 12.8125 5.64494 12.8125 5.85113Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaPrenotazioni);
export default __webpack_public_path__ + "static/media/icona-prenotazioni.bc23ba2e8839df1b11f37f1e46d9f2de.svg";
export { ForwardRef as ReactComponent };